// extracted by mini-css-extract-plugin
export default {"wrapper":"HrIdResult_wrapper__WBCBB"};